
const digest = '6e4e4905bfdae3e5648fa5a4ef48fe20e9ed2a8d580794a25c7be749a37fee07';
const classes = {"wrapper":"_wrapper_gv25l_1"};
const css = `._wrapper_gv25l_1 {
  display: flex;
  flex-direction: column;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  